module.exports = __webpack_public_path__ + "img/stop-circle.40abe30c.svg";